"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VoicesOfExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="3276" id="investor-success-stories" className="bg-secondary text-secondary-foreground py-24 overflow-hidden relative bg-[radial-gradient(circle_at_center,_rgba(184,146,64,0.12)_0%,_transparent_70%)]">
      <div ref={ref} className={cn("max-w-4xl mx-auto px-6 text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        {}
        <div className="mb-6 flex justify-center">
          <span className="font-serif text-[80px] leading-none text-primary select-none opacity-80">
            &ldquo;
          </span>
        </div>

        {}
        <blockquote className="mb-12">
          <p className="font-serif text-3xl md:text-4xl italic text-secondary-foreground leading-relaxed tracking-tight">
            YieldCapital has redefined our approach to secure wealth building, delivering consistent 10% returns with absolute transparency.
          </p>
        </blockquote>

        {}
        <div className="flex flex-col items-center gap-4">
          <SafeHydrate><Avatar className="h-16 w-16 border-2 border-primary shadow-lg shadow-black/20">
            <AvatarImage src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/avatar_jane_d.png" alt="Robert Sterling" className="object-cover" />
            <AvatarFallback className="text-lg font-default font-medium bg-muted text-muted-foreground">
              RS
            </AvatarFallback>
          </Avatar></SafeHydrate>

          <div className="space-y-1">
            <div className="font-default font-bold text-xl text-secondary-foreground tracking-wide">
              Robert Sterling
            </div>
            <div className="font-sans text-base text-primary font-medium">
              Portfolio Investor • +10.2% ROI
            </div>
          </div>
        </div>
      </div>
    </section>;
}